import Shift from "app/models/shift"
import { Action, Types } from "./shifts.actions"

export type ShiftsState = {
  data: Shift[] | undefined
  errors: {}
  loading: boolean
}

const initialState: ShiftsState = {
  data: [],
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): ShiftsState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...(state.data || []), action.payload],
      }

    case Types.POST_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      }

    case Types.PUT:
      return {
        ...state,
        loading: true,
      }
    case Types.PUT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data?.map(shift => (shift.id === action.payload.id ? action.payload : shift)),
      }
    case Types.PUT_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      }

    case Types.DELETE:
      return {
        ...state,
        loading: true,
      }
    case Types.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data?.filter(shift => shift.id !== action.payload),
      }
    case Types.DELETE_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
      }

    default:
      return state
  }
}
